var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"content-title"},[_c('h1',[_vm._t("title")],2),_c('h2',[_vm._t("subtitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }